export const getCanvasLogicalSize = (canvas) => {
  const dpr = window.devicePixelRatio || 1;
  return {
    width: canvas.__logicalWidth || (canvas.width / dpr),
    height: canvas.__logicalHeight || (canvas.height / dpr),
  };
};

// Compute the image's rendered rect in canvas logical/CSS pixels.
// Mirrors objectFit:contain + centering, then applies the same zoom/pan as the image CSS transform.
export const computeImgRect = (canvas, naturalSize, zoom = 1, panOffset = { x: 0, y: 0 }) => {
  const { width: logicalW, height: logicalH } = getCanvasLogicalSize(canvas);
  if (!naturalSize || !logicalW || !logicalH) {
    return { left: 0, top: 0, width: logicalW, height: logicalH };
  }
  const scale = Math.min(logicalW / naturalSize.width, logicalH / naturalSize.height);
  const baseW = naturalSize.width * scale;
  const baseH = naturalSize.height * scale;
  const baseLeft = (logicalW - baseW) / 2;
  const baseTop = (logicalH - baseH) / 2;
  const z = zoom || 1;
  const pan = panOffset || { x: 0, y: 0 };
  return {
    left: baseLeft + (baseW * (1 - z)) / 2 + (pan.x || 0),
    top: baseTop + (baseH * (1 - z)) / 2 + (pan.y || 0),
    width: baseW * z,
    height: baseH * z,
  };
};
